import greiffCasualRf from './GreiffCasualRf.jpg';

export const greiffCasualRfImpressions = {
    greiffCasualRf,
};
